import { render, staticRenderFns } from "./ModalTaxTableNew.vue?vue&type=template&id=6bfc52c4&"
import script from "./ModalTaxTableNew.vue?vue&type=script&lang=js&"
export * from "./ModalTaxTableNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports